import { DEFAULT_VANILLA_ENVIRONMENT_CONFIG } from '../../app/constants/prebakedEnvironments';
import type { DevSettings } from '../devSettings/devSettings.types';
import { getStoredDevSettings } from '../devSettings/getStoredDevSettings';

export const getDevSettings = (): DevSettings => {
  const stored = getStoredDevSettings();

  if (stored) {
    return stored;
  }

  return DEFAULT_VANILLA_ENVIRONMENT_CONFIG.devSettings;
};
